// Que escudo lleva un torneo en el tarjeton y en las listas.
//
// Los dos tienen logo (el dueno, 2026-09-05): el torneo interno tambien puede llevar
// el suyo. Manda el del torneo si lo tiene; si no, el de su liga; si no, nada (el
// tarjeton deja el hueco en blanco, que es su propia forma de decir "sin escudo").
// La liga llega con dos nombres segun la consulta (`liga` en el tarjeton, `ligas` en
// las listas).
export const logoDelTorneo = (torneo) =>
  torneo?.logo_url ||
  torneo?.liga?.logo_url ||
  torneo?.ligas?.logo_url ||
  null
